module.exports = __webpack_public_path__ + "img/img04.3f0a3ce3.svg";